import { fg } from '@atlaskit/platform-feature-flags';

export default {
	get(): boolean {
		return fg('rovo_fps_show_slack_top_reaction_in_search');
	},
};
